import { Spacer } from '@spritz-finance/ui'
import { FadePresence } from '../../../components/FadePresence'
import { CenteredPageInner } from '../../../components/Layout/PageContainer'
import { PageLoading } from '../../../components/PageLoading'
import { FullBankAccountFragment, useBankAccountsQuery } from '../../../graphql/generated/graphql'
import { AccountsList } from './AccountsList'
import { AddAccount } from './addAccount/AddAccount'
import { AddFirstAccountCard } from './addAccount/AddFirstAccountCard'

export type BankAccount = FullBankAccountFragment
type BankAccountContent = 'accounts' | 'addFirstAccount'

const BankAccountsContent = ({
    content,
    accounts,
}: {
    content: BankAccountContent
    accounts: BankAccount[]
}) => {
    switch (content) {
        case 'addFirstAccount':
            return <AddFirstAccountCard />

        default:
            return (
                <CenteredPageInner>
                    <AddAccount />
                    <Spacer height={32} />
                    <AccountsList accounts={accounts} />
                </CenteredPageInner>
            )
    }
}

export const BankAccounts = () => {
    const { data, loading } = useBankAccountsQuery()

    if (loading) return <PageLoading />

    const accounts = data?.bankAccounts ?? []

    const content = accounts.length > 0 ? 'accounts' : 'addFirstAccount'
    return (
        <FadePresence renderKey={content}>
            <BankAccountsContent content={content} accounts={accounts} />
        </FadePresence>
    )
}
